module.exports = __webpack_public_path__ + "img/Profile-12.cd0ed3cd.png";